<template>
	<div class="login-container">
		<div class="appheader">
			<div class="w">
				<div class="logo" @click="goHome" >
					<img :src="contact.logo" width="170" />
				</div>
			</div>
		</div>
		<div class="content">
		    <div class="lf-cover">
				<img src="../../assets/green.jpg">
			</div>
			<div class="form" >
				<div class="form-wrap">
                    <div class="form-title">Forget Password</div>
                    <div class="label-item">
				    	 Email
				    </div>
					<div class="form-item">
						<input type="text"  :placeholder="formData.emailplaceholder" v-model="formData.email" />
					</div>
					<div class="label-item">
				    	 Code
				    </div>
					<div class="form-item code-item" >
						<input type="text"  v-model="formData.code" autocomplete="off"/>
						<span @click="getCode">{{t == 61 ? 'Get code' : t + 's'}}</span>
					</div>

					<div class="label-item">
				    	 Password
				    </div>
					<div class="form-item ">
						<input type="password"  v-model="formData.password" autocomplete="off"/>
					</div>
					
					<div class="form-item btn-group clear-border" >

						<el-button type="success" class="btn login-btn" :loading="loading" @click="submit" >Log In</el-button>

						<el-button type="text" class="btn cancel-btn" @click="$router.go(-1)">Return</el-button>


						
						
					</div>
				</div>
			
			</div>
		</div>
	</div>
</template>	

<script>
    import {mapState} from 'vuex'


	export default {
		data () {
			return {
				formData:{
                    email:"",
                    code:"",
                    password:""

				},
				loading:false,
				timeOut: null,
				t: 61
			}
		},
		computed: {
			 ...mapState({
                  userInfo: state => state.userInfo,
                  contact: state => state.contact
            }),
		},
		mounted(){
                   
              
		},
		methods: {
			goHome(){
                  this.$router.push('/')
			},
			submit(){

                var app= this;
                app.loading = true;

                this.$api("/login/password",this.formData ).then(function(res){

                	app.loading = false;

                    if(res.status=="200"){
 
                        app.global_variable.showToast(res.msg);
 
                        setTimeout(function(){
                           app.$router.push("/login")
				        },1000)
				       
                    }

	            })
			},
			getCode () {

				var {t} = this

				if(!this.formData.email){
                    
                    this.global_variable.showToast("Please input your Email");

					return
				}

				if( t < 60) {
					return
				}
				var num = t;
				
				--num
				this.t = num;
				this.timeOut = setInterval(() => {
					--num
					if (num <= 0) {
						this.t = 61;
						clearInterval(this.timeOut);
						return
					}
					this.t = num
				}, 1000)

				this.$api("/login/SendSms",{email:this.formData.email,type:2} ).then(function(res){

	            })


				
			}
		}
	}
</script>







// WEBPACK FOOTER //
// src/pages/login/forget.vue